export function addScriptGroupsBiFields() {
	try {
		const groupsScriptResources = performance
			.getEntries()
			.filter(
				(entry) => entry.entryType === 'resource' && entry.name.includes('.js') && entry.name.includes('group_')
			)

		const countScripts = groupsScriptResources.length.toString()
		const totalScriptsSize = groupsScriptResources
			.map((resource: any) => resource.transferSize)
			.reduce((acc, current) => acc + current, 0)
			.toString()

		return {
			countScripts,
			totalScriptsSize,
		}
	} catch (e) {
		console.error(e)
		return {
			countScripts: '',
			totalScriptsSize: '',
		}
	}
}
